export default __webpack_public_path__ + "static/media/languagePic.45780286.png";